import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: "श्री. रविन्द्र उत्तम तातोडे ", designation: "गट ग्रामपंचायत लोणारा /चक्कीखपा ", phone: "+91 ९७६५९८९३२७", imageUrl: "/images/ravindra.jpeg" },
  { name: "श्री.सुशील शंकरराव चापकेलवार", designation: "गट ग्रामपंचायत लोणारा /चक्कीखपा" , phone: "+91 ९७६४६२७९१४", imageUrl: "/images/shusil.jpeg" },
  { name: "सौ.शुभांगी पंकज शेलारे", designation: "गट ग्रामपंचायत लोणारा /चक्कीखपा",  phone: "+91 ७६६६५९९८७०", imageUrl: "/images/shubangi.jpeg" },
  { name: "सौ.पायल युवराज कांबळे", designation: "गट ग्रामपंचायत लोणारा /चक्कीखपा", phone: "+91 ७८४१०६८८६१", imageUrl: "/images/payal.jpeg" },
  { name: "सौ. पूजा सोनू  खोब्रागडे ", designation: "गट ग्रामपंचायत लोणारा /चक्कीखपा  ",phone: "+91 ९३०९१३४८४४", imageUrl: "/images/puja.jpeg" },
  { name: "सौ. स्वाती दिपक आंजनकर", designation: "गट ग्रामपंचायत लोणारा /चक्कीखपा ", phone: "+91 ८४५९८५२६३८", imageUrl: "/images/swati.jpeg" },
];

const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
